import React from "react";
import { withTranslation } from "react-i18next";
import { getDateFormat } from "@utils/datePickerUtils";
import { FlexRow, ButtonData } from "./OrderPlanningHistory.styled";

const Tabs = (props) => {
  const { t, activeTab, toggleTab, orderData } = props;
  return (
    <FlexRow>
      {orderData.map((data, dataIndex) => {
        return (
          <React.Fragment
            key={"order-history-date-" + data?.id + "-" + dataIndex}
          >
            {data?.services?.map((serviceObj, serviceObjIndex) => {
              return (
                <ButtonData
                  key={
                    "order-history-date-" +
                    data?.id +
                    "-" +
                    dataIndex +
                    "-" +
                    serviceObjIndex
                  }
                  marginRight="10px"
                  color={
                    activeTab === serviceObj?.clientOrder?.planningDate
                      ? "#008395"
                      : "#cccccc"
                  }
                  onClick={() =>
                    toggleTab(serviceObj?.clientOrder?.planningDate)
                  }
                >
                  {getDateFormat(
                    serviceObj?.clientOrder?.planningDate,
                    "YYYY-MM-DD"
                  )}
                </ButtonData>
              );
            })}
          </React.Fragment>
        );
      })}
    </FlexRow>
  );
};

export default withTranslation()(Tabs);
